/* Project Import will be here */
import { post, IRequest } from "./index";
import { ISchemeProductDetailParams, ISchemeListParams } from "models/promotionModels";
/* Project Import will be here */

/* Scheme details and product list API information */
export const schemeProductDetailApi = (data: ISchemeProductDetailParams) => {
  const request: IRequest = {
    subUrl: `/Product/SchemeView`,
    data
  };

  return post(request);
};

/* Scheme list API information */
export const getSchemeList = (data: ISchemeListParams) => {
  const request: IRequest = {
    subUrl: `/Product/PromotionSchemes`,
    data
  };

  return post(request);
};

/* Get all discounts mapped to the product */
export const getProductDiscountListApi = (data: IDiscountListParams) => {
  const request: IRequest = {
    subUrl: `/Product/GetProductDiscountList`,
    data
  };

  return post(request);
};

/* API to fetch QPS scheme list */
export const getQpsSchemeListApi = () => {
  const request: IRequest = {
    subUrl: `/Product/QpsSchemes`,
  };

  return post(request);
};